import TopContentLayout from 'components/RwdBasket/RwdBasketLayout/TopContentMessages/TopContentLayout/TopContentLayout';

export default TopContentLayout;
